import { SharpenUpsellPromo } from '../interfaces/sharpen-upsell.interface';

/**
 * Maps the raw promo data from the Magento API to the SharpenUpsellPromo interface.
 *
 * @param promo
 */
export const mapSharpenUpsellPromo = (promo: any): SharpenUpsellPromo | undefined => {
  if (!promo) {
    return undefined;
  }

  return {
    couponCode: promo.coupon_code,
    discountAmount: promo.discount_amount,
    discountType: promo.discount_type,
    durationInDays: promo.duration_in_days,
    expirationDate: promo.expiration_date,
    name: promo.name,
  };
};

